import dayjs from 'dayjs';
import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { WebtoolsChangelogVersion } from '../model/webtools-changelog-version';
import { DtoChangelogVersionInterface } from '../interface/dto-webtools-changelog-version.interface';
import { DtoWebtoolsChangelogEntryInterface } from '../interface/dto-webtools-changelog-entry.interface';
import { WebtoolsChangelogEntryFactory } from './webtools-changelog-entry-factory';

export class WebtoolsChangelogVersionFactory
  extends QuickFactory
  implements Factory<WebtoolsChangelogVersion>
{
  build(o: DtoChangelogVersionInterface): WebtoolsChangelogVersion {
    const version: WebtoolsChangelogVersion = new WebtoolsChangelogVersion(
      o.id,
      null,
      o.title,
    );
    this.generateProperty(version, o);
    version.entries = o.entries.map((e: DtoWebtoolsChangelogEntryInterface) =>
      new WebtoolsChangelogEntryFactory().build(e),
    );
    version.date = o.date ? dayjs(o.date, 'DD/MM/YYYY').toDate() : null;
    version.createdAt = o.createdAt
      ? dayjs(o.createdAt, 'DD/MM/YYYY - HH:mm').toDate()
      : dayjs(o.date, 'DD/MM/YYYY').toDate();
    version.updatedAt = o.updatedAt
      ? dayjs(o.updatedAt, 'DD/MM/YYYY - HH:mm').toDate()
      : null;

    return version;
  }

  getApi(): string {
    return 'versions';
  }
}
